
import { Route, Routes, useLocation, Navigate, } from 'react-router-dom'
import { useAuth } from './provider';
import { CircularProgress, Box } from "@mui/material";

//import StartMain from "./PublicPages/StartPage/StartMain"
import ErrorPage from "./components/Errors/ErrorPage"

import Login from './Auth/Login/LogIn'
import RegisterPage from "./Auth/Register/RegisterPage"
import RegisterPage2Col from './Auth/Register/RegisterPage2Col'

import ForgotWelcome from './Auth/ForgotPassword/ForgotWelcome';
import ResetPasswordForm from './Auth/ForgotPassword/ResetPasswordForm';

import EmailPwPage from "./Auth/ForgotPassword/EmailPwPage"
import EmailConfPage from "./Auth/Register/EmailConfirmPage"
import RedeemGiftPage from "./Auth/GiftUser/RedeemGiftPage"

import CockpitWelcome from './ProtectedPages/CockpitWelcome/CockpitWelcome'
import RecommendationsWelcome from './ProtectedPages/CockpitWelcome/RecommendationsWelcome'
import MechanismsWelcome from './ProtectedPages/CockpitWelcome/MechanismsWelcome'
import DoctorNotesWelcome from './ProtectedPages/CockpitWelcome/DoctorNotesWelcome'
import WelcomepageRoot from './ProtectedPages/WelcomePage/WelcomepageRoot'

import MembershipConfig from './ProtectedPages/Onboarding/Membership/MembershipConfig'

import OnboardingData from './ProtectedPages/Onboarding/CompleteData/OnboardingData'
import LabAppointment from './ProtectedPages/Onboarding/LabAppointment/LabAppointment'
import FirstLabvisit from './ProtectedPages/Onboarding/LabAppointment/FirstLabvisit'; // new onboarding step
import AddonSelection from './ProtectedPages/Onboarding/LabAppointment/AddonSelection'; // new onboarding step
import OnboardingAddonSuccess from './ProtectedPages/Onboarding/LabAppointment/OnboardingAddonSuccess'; // new onboarding step, not yet linked from app navigation
import OnboardingAddonCancel from './ProtectedPages/Onboarding/LabAppointment/OnboardingAddonCancel'; // new onboarding step, not yet linked from app navigation
import OnbQuest from './ProtectedPages/Onboarding/Questionnaire/OnbQuest';
import NewQuestionnaire from './ProtectedPages/Onboarding/Questionnaire/NewQuestionnaire'; // new onboarding step
import MicrobiomeSampleStep from './ProtectedPages/Onboarding/Questionnaire/MicrobiomeSampleStep'; // new onboarding step
import LabvisitStep from './ProtectedPages/Onboarding/LabvisitStep/LabvisitStep'; // new onboarding step
import FirstLoginStep from './ProtectedPages/Onboarding/WaitingResults/FirstLoginStep'; // new onboarding step
import WaitingResults from './ProtectedPages/Onboarding/WaitingResults/WaitingResults'
import WaitingResultsSummary from './ProtectedPages/Onboarding/WaitingResults/WaitingResultsSummary'

import OnboardingWelcome from './ProtectedPages/Onboarding/Subscribe/OnboardingWelcome';
import OnbSubscription from './ProtectedPages/Onboarding/Subscribe/OnbSubscription'; // new onboarding step 1
import OnbGiftCode from './ProtectedPages/Onboarding/Subscribe/OnbGiftCode'; // alternative onboarding step 1 (gift code)
import OnboardingPay from './ProtectedPages/Onboarding/Subscribe/OnboardingPay'
import PaymentSuccess from './ProtectedPages/Onboarding/Subscribe/PaymentSuccess'
import PaymentError from './ProtectedPages/Onboarding/Subscribe/PaymentError'
import PaymentSuccessAddOn from './ProtectedPages/Onboarding/Subscribe/PaymentSuccessAddOn'
import StripeCancel from './ProtectedPages/Onboarding/Subscribe/StripeCancel'
import StripeNotCompleted from './ProtectedPages/Onboarding/Subscribe/StripeNotCompleted'; // replacement for StripeCancel, not yet linked from app navigation
import StripeSuccess from './ProtectedPages/Onboarding/Subscribe/StripeSuccess'; // new onboarding step, not yet linked from app navigation
import StripeRedirectBridge from './ProtectedPages/Onboarding/Subscribe/StripeRedirectBridge'
import WorkflowPaymentSuccess from './ProtectedPages/Onboarding/Subscribe/WorkflowPaymentSuccess'

import StateAddOn from './ProtectedPages/LabVisits/LabvisitWorkflow/StateAddOn';
import StateLabAppointment from './ProtectedPages/LabVisits/LabvisitWorkflow/StateLabAppointment';
import StateQuest from './ProtectedPages/LabVisits/LabvisitWorkflow/StateQuest';
import StateWaiting from './ProtectedPages/LabVisits/LabvisitWorkflow/StateWaiting';
import LabvisitStepAdmin from './ProtectedPages/LabVisits/LabvisitWorkflow/LabvisitStepAdmin';
import LabVisitAddonSuccess from './ProtectedPages/LabVisits/LabvisitWorkflow/LabVisitAddonSuccess';
import MicrobiomePath from './ProtectedPages/LabVisits/LabvisitWorkflow/MicrobiomePath';

import OnboardingSub from './ProtectedPages/MainWelcome/Onboarding/OnboardingSubs'
import OnboardingCollection from './ProtectedPages/MainWelcome/Onboarding/OnboardingCollection'
import MainWelcome from "./ProtectedPages/MainWelcome/MainWelcome"

import BioAgeWelcome from './ProtectedPages/CockpitWelcome/Epigenetics/BioAge/BioAgeWelcome';
import MetabolicHealthWelcome from './ProtectedPages/CockpitWelcome/HealthSystems/MetabolicHealth/MetabolicHealthWelcome';
import OrganHealthWelcome from './ProtectedPages/CockpitWelcome/HealthSystems/OrganHealth/OrganHealthWelcome';
import ImmuneHealthWelcome from './ProtectedPages/CockpitWelcome/HealthSystems/ImmuneHealth/ImmuneHealthWelcome';
import NutrientHealthWelcome from './ProtectedPages/CockpitWelcome/HealthSystems/NutrientHealth/NutrientHealthWelcome';

import WatchlistWelcome from './ProtectedPages/CockpitWelcome/Genetics/Watchlist/WatchlistWelcome'
import GeneticsWelcome from './ProtectedPages/CockpitWelcome/Genetics/HeredityDisease/GeneticsWelcome'
import CancerRiskWelcome from './ProtectedPages/CockpitWelcome/Genetics/HeredityCancer/CancerRiskWelcome'
import SearchWelcome from './ProtectedPages/CockpitWelcome/Genetics/SearchBrowser/SearchWelcome'
import NewbornWelcome from './ProtectedPages/CockpitWelcome/Genetics/NewbornPanel/NewbornWelcome'

import EpigeneticsWelcome from './ProtectedPages/CockpitWelcome/Epigenetics/EpigeneticsWelcome'
import LongevityWelcome from './ProtectedPages/CockpitWelcome/Epigenetics/Longevity/LongevityWelcome'

import GutMicrobiomeWelcome from './ProtectedPages/CockpitWelcome/Microbiome/GutMicrobiome/GutMicrobiomeWelcome';
import GutKitWelcome from './ProtectedPages/CockpitWelcome/Microbiome/GutKitActivation/GutKitWelcome';
import QuestionnaireWelcome from './ProtectedPages/CockpitWelcome/Questionnaire/BiomaPlus/QuestionnaireWelcome';
import FeedbackWelcome from './ProtectedPages/CockpitWelcome/Feedback/FeedbackWelcome';
import MouthMicrobiomeWelcome from './ProtectedPages/CockpitWelcome/Microbiome/MouthMicrobiome/MouthMicrobiomeWelcome'
import VitalsWelcome from './ProtectedPages/CockpitWelcome/BiometricVitals/VitalsWelcome'

import BloodCoreWelcome from './ProtectedPages/CockpitWelcome/Bloodmarker/BloodCore/BloodCoreWelcome';
import BloodArterioWelcome from './ProtectedPages/CockpitWelcome/Bloodmarker/BloodArterio/BloodArterioWelcome';
import BloodHormonesWelcome from './ProtectedPages/CockpitWelcome/Bloodmarker/BloodHormones/BloodHormonesWelcome';
import BloodBonesWelcome from './ProtectedPages/CockpitWelcome/Bloodmarker/BloodBones/BloodBonesWelcome';
import BloodVitaminsWelcome from './ProtectedPages/CockpitWelcome/Bloodmarker/BloodVitamins/BloodVitaminsWelcome';
import BloodThyroidWelcome from './ProtectedPages/CockpitWelcome/Bloodmarker/BloodThyroid/BloodThyroidWelcome';
import BloodPsaWelcome from './ProtectedPages/CockpitWelcome/Bloodmarker/BloodPsa/BloodPsaWelcome';


import BloodAddonsWelcome from './ProtectedPages/CockpitWelcome/Bloodmarker/BloodAddons/BloodAddonsWelcome';
import BloodOmegaWelcome from './ProtectedPages/CockpitWelcome/Bloodmarker/BloodOmega/BloodOmegaWelcome';
import OmegaDetails from './ProtectedPages/CockpitWelcome/Bloodmarker/BloodOmega/OmegaDetails/OmegaDetails';
import BloodFertilityWelcome from './ProtectedPages/CockpitWelcome/Bloodmarker/Fertility/BloodFertilityWelcome';

import StoolWelcome from './ProtectedPages/CockpitWelcome/Stool/FobCancer/StoolWelcome';
import CalWelcome from './ProtectedPages/CockpitWelcome/Stool/CalInflammation/CalWelcome';

import CycleTrackerDashboard from './ProtectedPages/CockpitWelcome/PeriodTracker/CycleTrackerDashboard'

import OrderTests from "./PublicPages/OrderTests/OrderTestsPage"

import ArchiveWelcome from "./ProtectedPages/CockpitWelcome/Genetics/GenomeArchive/ArchiveWelcome"
import ClockWelcome from './ProtectedPages/MainWelcome/BioAge/ClockWelcome'

import RecordsWelcome from './ProtectedPages/HealthRecords/RecordsWelcome'
import MedicationWelcome from './ProtectedPages/CockpitWelcome/Medication/MedicationWelcome'
import UserLabreportsWelcome from './ProtectedPages/CockpitWelcome/LabReports/UserLabreportsWelcome'
import VaccsWelcome from './ProtectedPages/HealthRecords/VaccsSection/VaccsWelcome'
import FamilyWelcome from './ProtectedPages/HealthRecords/FamilyWelcome/FamilyWelcome'

import LabfinderWelcome from './ProtectedPages/Labfinder/LabfinderWelcome'

import UserAdminWelcome from "./ProtectedPages/UserAdmin/UserAdminWelcome"
import PasswordChangeWelcome from "./ProtectedPages/UserAdmin/PasswordChangeWelcome"
import LabVisitsWelcome from './ProtectedPages/LabVisits/LabVisitsWelcome';
import SubscriptionWelcome from './ProtectedPages/Subscription/SubscriptionWelcome'
import AddOnsWelcome from './ProtectedPages/Subscription/AddOnsWelcome';
import UpdatePlan from './ProtectedPages/Subscription/SubscriptionPlans/Upgrade/UpgradeDetails'

import CvdWelcome from './ProtectedPages/ModuleWelcome/CvdModule/CvdWelcome'

import CancerWelcome from './ProtectedPages/MainWelcome/Cancer/CancerWelcome'

import BloodtestsWelcome from './ProtectedPages/CockpitWelcome/Bloodtests/BloodtestsWelcome'
import StooltestsWelcome from './ProtectedPages/CockpitWelcome/Stooltests/StooltestsWelcome'

import DrugWelcome from './ProtectedPages/CockpitWelcome/PharmacoPgx/MedicationGuide/DrugWelcome'
import PgxWelcome from './ProtectedPages/CockpitWelcome/PharmacoPgx/PgxGenotypes/PgxWelcome'

import DoctorWelcome from './ProtectedPages/Doctor/DoctorWelcome'
import MeetingWelcome from './ProtectedPages/Doctor/Meeting/MeetingWelcome'
import DesignSystemPage from './DesignSystem/DesignSystemPage'
import HormoneAddonPreview from './ProtectedPages/CockpitWelcome/Bloodmarker/BloodHormones/TestPage/HormoneAddonPreview'
import CycleTrackerPreview from './ProtectedPages/CockpitWelcome/PeriodTracker/CyclePeriod/CycleTrackerPreview'



function RequireAuth({ children }) {
  
  const { state, authLoading} = useAuth();
  const { user } = state;

  // Wait for auth to finish loading from localStorage
  if (authLoading) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '100vh' 
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // After loading completes, check if user exists
  if (!user) {
    return <Navigate to="/" replace />;
  }

  return children;
}


export const RoutesPages = () => (

  <Routes>
    
    <Route path="/reset-password/:token" element={<ResetPasswordForm />} />

      <Route path="/" element={<Login />} />     
      <Route path="/ErrorPage" element={<ErrorPage />} />
        <Route path="/StripeRedirectBridge" element={<StripeRedirectBridge />} ></Route>

      <Route path="/Login" element={<Login />} />
      <Route path="/RegisterPage" element={<RegisterPage />} />
      <Route path="/RegisterPage2Col" element={<RegisterPage2Col />} />
      <Route path="/EmailPage" element={<EmailConfPage />} />
      <Route path="/EmailPwPage" element={<EmailPwPage />} />
      <Route path="/redeem/:code" element={<RedeemGiftPage />} />

      <Route path="/ForgotWelcome" element={<ForgotWelcome />} />
      

      <Route path="/OnboardingData" element={<OnboardingData />} />
      <Route path="/OrderTests" element={<OrderTests />} />
      <Route path="/DesignSystem" element={<DesignSystemPage />} />
      <Route path="/HormoneAddonPreview" element={<HormoneAddonPreview />} />
      <Route path="/CycleTrackerPreview" element={<CycleTrackerPreview />} />

    <Route path="/Welcome" element={ <RequireAuth> <WelcomepageRoot /> </RequireAuth> } ></Route>
    <Route path="/CockpitWelcome" element={ <RequireAuth> <CockpitWelcome /> </RequireAuth> } ></Route>
    <Route path="/MechanismsWelcome" element={ <RequireAuth> <MechanismsWelcome /> </RequireAuth> } ></Route>
    <Route path="/RecommendationsWelcome" element={ <RequireAuth> <RecommendationsWelcome /> </RequireAuth> } ></Route>
    <Route path="/DoctorNotesWelcome" element={ <RequireAuth> <DoctorNotesWelcome /> </RequireAuth> } ></Route>
      
       <Route path="/MembershipConfig" element={<RequireAuth> <MembershipConfig /> </RequireAuth> } ></Route>

      <Route path="/OnboardingData" element={<RequireAuth> <OnboardingData /> </RequireAuth> } ></Route>
      <Route path="/LabAppointment" element={<RequireAuth> <LabAppointment /> </RequireAuth> } ></Route>
      <Route path="/FirstLabvisit" element={<RequireAuth> <FirstLabvisit /> </RequireAuth> } ></Route>{/* new onboarding step */}
      <Route path="/AddonSelection" element={<RequireAuth> <AddonSelection /> </RequireAuth> } ></Route>{/* new onboarding step */}
      <Route path="/OnboardingAddonSuccess" element={<RequireAuth> <OnboardingAddonSuccess /> </RequireAuth> } ></Route>{/* new onboarding step, not yet linked from app navigation */}
      <Route path="/OnboardingAddonCancel" element={<RequireAuth> <OnboardingAddonCancel /> </RequireAuth> } ></Route>{/* new onboarding step, not yet linked from app navigation */}
      <Route path="/NewQuestionnaire" element={<RequireAuth> <NewQuestionnaire /> </RequireAuth> } ></Route>{/* new onboarding step */}
      <Route path="/MicrobiomeSampleStep" element={<RequireAuth> <MicrobiomeSampleStep /> </RequireAuth> } ></Route>{/* new onboarding step */}
      <Route path="/LabvisitStep" element={<RequireAuth> <LabvisitStep /> </RequireAuth> } ></Route>{/* new onboarding step */}
      <Route path="/FirstLoginStep" element={<RequireAuth> <FirstLoginStep /> </RequireAuth> } ></Route>{/* new onboarding step */}
      <Route path="/OnbQuest" element={<RequireAuth> <OnbQuest /> </RequireAuth> } ></Route>
      <Route path="/WaitingResults" element={<RequireAuth> <WaitingResults /> </RequireAuth> } ></Route>
      <Route path="/PaymentSuccessAddOn" element={<RequireAuth> <PaymentSuccessAddOn /> </RequireAuth> } ></Route>
      <Route path="/WaitingResultsSummary" element={<RequireAuth> <WaitingResultsSummary /> </RequireAuth> } ></Route>

      <Route path="/OnboardingWelcome" element={<RequireAuth> <OnboardingWelcome /> </RequireAuth> } ></Route>
      <Route path="/OnbSubscription" element={<RequireAuth> <OnbSubscription /> </RequireAuth> } ></Route>{/* new onboarding step 1 */}
      <Route path="/OnbGiftCode" element={<RequireAuth> <OnbGiftCode /> </RequireAuth> } ></Route>{/* alternative onboarding step 1 (gift code) */}
      <Route path="/StripeSuccess" element={<RequireAuth> <StripeSuccess /> </RequireAuth> } ></Route>{/* new onboarding step, not yet linked from app navigation */}
      <Route path="/OnboardingSub" element={<RequireAuth> <OnboardingSub /> </RequireAuth> } ></Route>
      <Route path="/OnboardingPay" element={<RequireAuth> <OnboardingPay /> </RequireAuth> } ></Route>
      <Route path="/PaymentSuccess" element={<RequireAuth> <PaymentSuccess /> </RequireAuth> } ></Route>
       <Route path="/PaymentError" element={<RequireAuth> <PaymentError /> </RequireAuth> } ></Route>
        <Route path="/StripeCancel" element={<RequireAuth> <StripeCancel /> </RequireAuth> } ></Route>
        <Route path="/StripeNotCompleted" element={<RequireAuth> <StripeNotCompleted /> </RequireAuth> } ></Route>{/* replacement for StripeCancel, not yet linked from app navigation */}
        <Route path="/WorkflowPaymentSuccess" element={<RequireAuth> <WorkflowPaymentSuccess /> </RequireAuth> } ></Route>

      <Route path="/StateAddOn" element={<RequireAuth> <StateAddOn /> </RequireAuth> } ></Route>
      
      <Route path="/StateLabAppointment/:labVisitId" element={<RequireAuth> <StateLabAppointment /> </RequireAuth> } ></Route> 
       <Route path="/StateLabAppointment" element={<RequireAuth> <StateLabAppointment /> </RequireAuth> } ></Route> 

      <Route path="/StateQuest" element={<RequireAuth> <StateQuest /> </RequireAuth> } ></Route>
      <Route path="/StateWaiting" element={<RequireAuth> <StateWaiting /> </RequireAuth> } ></Route>
      <Route path="/LabvisitStepAdmin" element={<RequireAuth> <LabvisitStepAdmin /> </RequireAuth> } ></Route>

      <Route path="/LabVisitAddonSuccess" element={<RequireAuth> <LabVisitAddonSuccess /> </RequireAuth> } ></Route>
      <Route path="/MicrobiomePath" element={<RequireAuth> <MicrobiomePath /> </RequireAuth> } ></Route>


      <Route path="/OnboardingCollection" element={<RequireAuth> <OnboardingCollection /> </RequireAuth> } ></Route>

     
      
       <Route path="/BioAgeWelcome" element={ <RequireAuth> <BioAgeWelcome /> </RequireAuth> } ></Route>
       <Route path="/MetabolicHealthWelcome" element={ <RequireAuth> <MetabolicHealthWelcome /> </RequireAuth> } ></Route>
        <Route path="/OrganHealthWelcome" element={ <RequireAuth> <OrganHealthWelcome /> </RequireAuth> } ></Route>
         <Route path="/ImmuneHealthWelcome" element={ <RequireAuth> <ImmuneHealthWelcome /> </RequireAuth> } ></Route>
          <Route path="/NutrientHealthWelcome" element={ <RequireAuth> <NutrientHealthWelcome /> </RequireAuth> } ></Route>



      <Route path="/UserAdminWelcome" element={ <RequireAuth> <UserAdminWelcome /> </RequireAuth> } ></Route>
      <Route path="/PasswordChangeDashboard" element={ <RequireAuth> <PasswordChangeWelcome /> </RequireAuth> } ></Route>
      <Route path="/MainWelcome" element={ <RequireAuth> <MainWelcome /> </RequireAuth> } ></Route>
       <Route path="/VitalsWelcome" element={ <RequireAuth> <VitalsWelcome /> </RequireAuth> } ></Route> 

      <Route path="/LabVisitsWelcome" element={ <RequireAuth> <LabVisitsWelcome /> </RequireAuth> } ></Route>
      <Route path="/SubscriptionWelcome" element={ <RequireAuth> <SubscriptionWelcome /> </RequireAuth> } ></Route>
      <Route path="/AddOnsWelcome" element={ <RequireAuth> <AddOnsWelcome /> </RequireAuth> } ></Route>
      <Route path="/UpdatePlan" element={ <RequireAuth> <UpdatePlan /> </RequireAuth> } ></Route>

      <Route path="/WatchlistWelcome" element={ <RequireAuth> <WatchlistWelcome /> </RequireAuth> } ></Route> 
      <Route path="/GeneticsWelcome" element={ <RequireAuth> <GeneticsWelcome /> </RequireAuth> } ></Route> 
      <Route path="/CancerRiskWelcome" element={ <RequireAuth> <CancerRiskWelcome /> </RequireAuth> } ></Route>
      <Route path="/SearchWelcome" element={ <RequireAuth> <SearchWelcome /> </RequireAuth> } ></Route>
      <Route path="/NewbornWelcome" element={ <RequireAuth> <NewbornWelcome /> </RequireAuth> } ></Route>
      <Route path="/ArchiveWelcome" element={ <RequireAuth> <ArchiveWelcome /> </RequireAuth> } ></Route>

      <Route path="/EpigeneticsWelcome" element={ <RequireAuth> <EpigeneticsWelcome /> </RequireAuth> } ></Route> 
      <Route path="/LongevityWelcome" element={ <RequireAuth> <LongevityWelcome /> </RequireAuth> } ></Route> 

      <Route path="/GutMicrobiomeWelcome" element={ <RequireAuth> <GutMicrobiomeWelcome /> </RequireAuth> } ></Route> 
      <Route path="/GutKitWelcome" element={ <RequireAuth> <GutKitWelcome /> </RequireAuth> } ></Route> 
       <Route path="/QuestionnaireWelcome" element={ <RequireAuth> <QuestionnaireWelcome /> </RequireAuth> } ></Route>
      <Route path="/FeedbackWelcome" element={ <RequireAuth> <FeedbackWelcome /> </RequireAuth> } ></Route>
      <Route path="/MouthMicrobiomeWelcome" element={ <RequireAuth> <MouthMicrobiomeWelcome /> </RequireAuth> } ></Route> 

      <Route path="/BloodCoreWelcome" element={ <RequireAuth> <BloodCoreWelcome /> </RequireAuth> } ></Route> 
      <Route path="/BloodArterioWelcome" element={ <RequireAuth> <BloodArterioWelcome /> </RequireAuth> } ></Route> 
      <Route path="/BloodHormonesWelcome" element={ <RequireAuth> <BloodHormonesWelcome /> </RequireAuth> } ></Route> 
       <Route path="/BloodBonesWelcome" element={ <RequireAuth> <BloodBonesWelcome /> </RequireAuth> } ></Route> 
       <Route path="/BloodVitaminsWelcome" element={ <RequireAuth> <BloodVitaminsWelcome /> </RequireAuth> } ></Route> 
      <Route path="/BloodThyroidWelcome" element={ <RequireAuth> <BloodThyroidWelcome /> </RequireAuth> } ></Route> 
      <Route path="/BloodPsaWelcome" element={ <RequireAuth> <BloodPsaWelcome /> </RequireAuth> } ></Route> 


      <Route path="/BloodAddonsWelcome" element={ <RequireAuth> <BloodAddonsWelcome /> </RequireAuth> } ></Route> 
        <Route path="/BloodOmegaWelcome" element={ <RequireAuth> <BloodOmegaWelcome /> </RequireAuth> } ></Route>
        <Route path="/OmegaDetails" element={ <RequireAuth> <OmegaDetails /> </RequireAuth> } ></Route>

    <Route path="/StoolWelcome" element={ <RequireAuth> <StoolWelcome /> </RequireAuth> } ></Route>
    <Route path="/CalWelcome" element={ <RequireAuth> <CalWelcome /> </RequireAuth> } ></Route>

      <Route path="/BloodtestsWelcome" element={ <RequireAuth> <BloodtestsWelcome /> </RequireAuth> } ></Route>
      <Route path="/StooltestsWelcome" element={ <RequireAuth> <StooltestsWelcome /> </RequireAuth> } ></Route>

      <Route path="/LabfinderWelcome" element={ <RequireAuth> <LabfinderWelcome /> </RequireAuth> } ></Route> 
      
      
      <Route path="/PeriodTrackerWelcome" element={ <RequireAuth> <CycleTrackerDashboard /> </RequireAuth> } ></Route> 
        <Route path="/BloodFertilityWelcome" element={ <RequireAuth> <BloodFertilityWelcome /> </RequireAuth> } ></Route> 
         
      <Route path="/ClockWelcome" element={ <RequireAuth> <ClockWelcome /> </RequireAuth> } ></Route>
    

      <Route path="/RecordsWelcome" element={ <RequireAuth> <RecordsWelcome /> </RequireAuth> } ></Route>
      <Route path="/MedicationWelcome" element={ <RequireAuth> <MedicationWelcome /> </RequireAuth> } ></Route>
      <Route path="/UserLabreportsWelcome" element={ <RequireAuth> <UserLabreportsWelcome /> </RequireAuth> } ></Route>
      <Route path="/VaccsWelcome" element={ <RequireAuth> <VaccsWelcome /> </RequireAuth> } ></Route>
      <Route path="/FamilyWelcome" element={ <RequireAuth> <FamilyWelcome /> </RequireAuth> } ></Route>
      
      <Route path="/CVDWelcome" element={ <RequireAuth> <CvdWelcome /> </RequireAuth> } ></Route>
      <Route path="/CancerWelcome" element={ <RequireAuth> <CancerWelcome /> </RequireAuth> } ></Route>

      <Route path="/Drugs" element={ <RequireAuth> <DrugWelcome /> </RequireAuth> } ></Route>
      <Route path="/Pgx" element={ <RequireAuth> <PgxWelcome /> </RequireAuth> } ></Route>

      <Route path="/Doctor" element={ <RequireAuth> <DoctorWelcome /> </RequireAuth> } ></Route>
      <Route path="/Meeting" element={ <RequireAuth> <MeetingWelcome /> </RequireAuth> } ></Route>
      

   

  </Routes>

)


